module.exports = __webpack_public_path__ + "img/img_1.bb9c5a80.png";